import { LiveEventsPageLoading } from '@/components/live/feed/live-events-page-loading';

export default function LiveEventsLoading(): React.ReactNode {
  return <LiveEventsPageLoading />;
}
